__turbopack_context__.v({
  "data": "DetailsItem-module-scss-module__AMmY7G__data",
  "delimiter": "DetailsItem-module-scss-module__AMmY7G__delimiter",
});
